import clsx from 'clsx';
import React from 'react';

import { ShouldRender } from '../basic/ShouldRender';

interface HeadingProps {
  heading: string;
  subHeading?: string;
  isSmall?: boolean;
}

const HeadingV2: React.FC<HeadingProps> = ({
  heading,
  subHeading,
  isSmall = false,
}) => {
  return (
    <>
      <div className='flex flex-col gap-y-6'>
        <div className='flex gap-x-2 md:gap-x-7 items-center'>
          <span
            className={clsx(
              ' leading-7 text-fadedWhite text-center  w-full',
              isSmall
                ? 'text-xl text-white font-medium'
                : 'text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-medium ',
            )}
          >
            {heading}
          </span>
        </div>

        <ShouldRender check={subHeading}>
          <div className='flex flex-col  text-gray-900 leading-loose'>
            <span className='text-2xl font-medium'>{subHeading}</span>
          </div>
        </ShouldRender>
      </div>
    </>
  );
};

export default HeadingV2;
